"use client";

import { VercelToolbar } from "@vercel/toolbar/next";

import { usePlatformPermissions } from "@/lib/auth/client";

export function TheVercelToolbar() {
  const { isPlatformAdmin } = usePlatformPermissions();

  // Only show in production or preview environments
  const isProductionOrPreview =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

  // Don't render in development to avoid CSP issues
  if (process.env.NODE_ENV === "development") {
    return null;
  }

  return isPlatformAdmin && isProductionOrPreview ? <VercelToolbar /> : null;
}
